<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="success"
        block
        v-on="on"
      >
        Create Course
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Course"
      text="Create Course"
      class="mb-0"
    > 
      <form v-if="dialog">
        <v-container>
          <v-row no-gutters> 
            <v-col cols="12">
              <v-text-field
                v-model="name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"                
                label="Course Name"
              />
            </v-col>

            <v-col
              cols="12"
              class="mb-0 pb-0 pt-0"
            >
              <v-autocomplete
                v-model="courseCategory"
                v-validate="'required'"
                :loading="loading"
                :items="courseCategories"
                label="Select Course Category"
                data-vv-name="promiser_uid"
                data-vv-as="Course Category"
                hide-selected
                item-text="name"
                item-value="id"
                :error-messages="errors.collect('promiser_uid')"
              />
            </v-col>

            <v-col cols="12">
              <v-textarea
                v-model="description"
                v-validate="'required'"
                data-vv-name="description"
                data-vv-as="Description"
                :error-messages="errors.collect('description')"
                solo
                name="input-7-4"
                label="Description"
                placeholder="Course description"
              />
            </v-col>

            <v-col
              cols="12"
              class="mb-0 pb-0 pt-0"
            >
              <v-autocomplete
                v-model="classroomType"
                v-validate="'required'"
                :loading="loading"
                :items="classroomTypes"
                label="Select Classroom Type"
                data-vv-name="classroom_type_id"
                data-vv-as="Classroom Type"
                hide-selected
                item-text="name"
                item-value="id"
                :error-messages="errors.collect('classroom_type_id')"
              />
            </v-col>

            <!-- TEMPORARY DISABLE -->
            <!-- <v-col
              cols="12"
              class="pb-0"
            >
              <v-autocomplete
                v-model="award"
                :items="awards"
                :loading="loading"
                label="Awards Completing Course"
                item-text="name"
                item-value="id"
                hide-selected
                multiple
                chips
                deletable-chips
              >
                <template v-slot:selection="data">
                  <v-chip
                    v-bind="data.attrs"
                    :input-value="data.selected"
                    close
                    @click="data.select"
                    @click:close="remove(award,data.item)"
                  >
                    <v-avatar left>
                      <v-img :src="data.item.image_url" />
                    </v-avatar>
                    {{ data.item.name }}
                  </v-chip>
                </template>

                <template v-slot:item="data">
                  <v-list-item-avatar>
                    <img :src="data.item.image_url">
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title v-html="data.item.name" />
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>
          
            <v-col
              cols="12"
              class="pb-0"
            >
              <v-autocomplete
                v-model="skill"
                :loading="loading"
                :items="skills"
                label="Skills Completing Course"
                hide-selected
                item-text="name"
                item-value="level.id"
                multiple
                chips
                deletable-chips
              >
                <template v-slot:selection="data">
                  <v-chip
                    v-bind="data.attrs"
                    :input-value="data.selected"
                    close
                    @click="data.select"
                    @click:close="remove(skill,data.item)"
                  >
                    <v-avatar left>
                      <v-img :src="data.item.image_url" />
                    </v-avatar>
                    <span class="text-truncate">
                      {{ data.item.level.description }}
                    </span>
                  </v-chip> 
                </template>

                <template v-slot:item="data">
                  <v-list-item-avatar>
                    <img :src="data.item.image_url">
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title v-html="data.item.name" />
                    <v-list-item-subtitle v-html="data.item.level.description" />
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col> -->

            <v-col cols="12">
              <helper-image-input  
                v-model="image" 
                :max-size-in-mb="2"
                data-vv-name="image"
                field-name="image"
                accept-type=".jpg,.jpeg,.png"            
              >          
                <div 
                  slot="activator"
                  class="mb-2"
                >   
                  <v-btn                    
                    :disabled="progressing"
                    class="mx-2"    
                  >
                    Add Image
                  </v-btn>
                  <span>
                    {{ image ? image.imageFile.name : 'No file chosen (.jpg/.png only)' }}
                  </span>
                </div>
              </helper-image-input>
              <span class="red--text text--lighten-1">{{ errors.first('image') }}</span>
            </v-col>
          </v-row>
        </v-container>
      </form>
      
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    components: {
      HelperImageInput: () => import('@/components/helper/ImageInput'),
    },
    data () {
      return {
        progressing: false,
        dialog: null,
        name: null,
        description: null,
        classroomTypes: [],
        courseCategories: [],
        classroomType: null,
        courseCategory: null,
        image: null,
        awards: [],
        award: [],
        skills: [],
        skill: [],
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) {
          this.$validator.reset()          
          this.$resetData()
        } else {
          this.loadData()
        }
      },
    },
    methods: { 
      loadData () {
        this.loading = true

        Promise.all([
          this.$api.classroomTypes().list(),
          this.$api.courseCategories().list(),
          this.$api.awards().list(),
          this.$api.skills().list(['levels']),
        ])
          .then(([classroomTypes, courseCategories, awards, skills]) => {
            let temp = []
            this.classroomTypes = classroomTypes.data
            this.courseCategories = courseCategories.data
            this.awards = awards.data
            
            skills.data.map((skill, i) => {
              skill.levels.forEach((level, index) => {
                temp.push({ 
                  category: skill.category,
                  id: i * 5 + index + 1,
                  image_path: skill.image_path,
                  image_url: skill.image_url,
                  level_counts: skill.level_count,
                  name: skill.name,
                  skill_category_id: skill.skill_category_id, 
                  level: { 
                    description: skill.levels[index].description,
                    id: skill.levels[index].id,
                    level: skill.levels[index].level,
                    skill_id: skill.levels[index].skill_id,
                  },
                })
              })  
            })
            this.skills = temp

            this.loading = false
          })
          .then(() => {
            this.loading = false
          })                 
      },
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.setProgressing(true)
    
            this.$api.courses().create(this.prepareFormData())
              .then((res) => {
                if (res.status === 201) {
                  this.$emit('created', res.data)                
                  this.$snack({ message: 'Added new course type' })

                  this.setDialog(false)                
                }
              })
              .catch(() => {})
              .then(() => {
                this.setProgressing(false)
              })
          })
      },
      prepareFormData () {
        if (!this.image) {
          return {
            'name': this.name,
            'description': this.description,
            'classroom_type_id': this.classroomType,
            'course_category_id': this.courseCategory,
            'award_ids': this.award,
            'skill_level_ids': this.skill,
          }
        }

        this.image.formData.set('name', this.name)
        this.image.formData.set('description', this.description)
        this.image.formData.set('classroom_type_id', this.classroomType)
        this.image.formData.set('course_category_id', this.courseCategory)
        this.image.formData.set('award_ids', this.award)
        this.image.formData.set('skill_level_ids', this.skill)

        return this.image.formData
      },   
      setProgressing (status) {
        this.progressing = status
      },
      setDialog (status) {
        this.dialog = status
      },
      resetForm () {
        this.$validator.reset()
        this.name = null
      },
      remove (array, item) {
        const index = array.indexOf(item.id)
        if (index >= 0) array.splice(index, 1)
      },
    },
  }
</script>

<style scoped>
.text-truncate{
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>
